import { FILTER_NAMES } from '../components/filters/hooks/filter-names.constants';
import {
  OPERATIONS,
  VALUE_MATCH,
} from '../hooks/filters/interfaces/filter-selected-value.interface';
import { AppNavigation } from '../routes/layout/components/navigation/interfaces/navigation.interface';

export const aboutButton: AppNavigation = {
  icon: '',
  id: 'about',
  name: 'Learn More',
  path: '/about',
  className: 'btn-lg btn-light btn-animated',
};
export const tutorialButton: AppNavigation = {
  icon: '',
  id: 'training',
  name: 'View Tutorials',
  path: '/training/tutorials',
  className: 'btn-lg p-18 border-radius-8',
};

export const resourcesButton: AppNavigation = {
  icon: '',
  id: 'resources',
  name: 'View All Resources',
  path: '/training',
  className: 'btn btn-animated border-radius-8 p-18',
};

export const ViewAllDashboardButton: AppNavigation = {
  icon: '',
  id: 'viewalldashboard',
  name: 'View All',
  path: '/training',
  className: 'btn btn-animated text-right p-18 border-radius-8',
};

export const ViewAllHeaderButtonList: AppNavigation[] = [
  {
    icon: '',
    id: 'ViewDemandModel',
    name: 'View Demand Model',
    path: '/t/r',
    className:
      'btn-nav-link btn btn-primary btn-animated requestaccessbutton border-radius-10 p-18 text-white',
  },
  {
    icon: '',
    id: 'ViewAllModels',
    name: 'View All Models',
    path: '/training',
    className: 'viewAllModels btn btn-animated p-18 border-radius-10',
  },
];

export const requestAccessNav: AppNavigation = {
  icon: '',
  id: 'request-access',
  name: 'Request Access',
  path: '/help-center/request-access',
  className: 'btn-lg btn-animated',
};

interface MatchStrategy {
  valueMatch: string;
  operation: string;
}

const matchStrategy: MatchStrategy = {
  valueMatch: VALUE_MATCH.SINGLE,
  operation: OPERATIONS.AND,
};

interface CategoryFilter {
  className: string;
  id: string;
  values: {
    label: string;
    value: string;
    e: string;
  }[];
  matchStrategy: MatchStrategy;
}

export const categoriesFilter: CategoryFilter[] = [
  {
    className: 'family-care',
    id: FILTER_NAMES.METACATEGORY,
    values: [
      {
        label: 'Family Care',
        value: 'Family Care',
        e: 'NobwRAlgJmBcYFsCmAXAhgYTSpBzA9gE4CeYANGAG5oA2ArkgM5yhW0NxgBiaCENxAARZCScmBpoARkhqcefAcLSiwAXwC6FBNgDGACwDKKQtjylY4avSQBZPfs6MIAO1w0xFfAAckplBD4LpxoLjBqmkA',
      },
    ],
    matchStrategy,
  },
  {
    className: 'baby-and-child',
    id: FILTER_NAMES.METACATEGORY,
    values: [
      {
        label: 'Baby/Child Care',
        value: 'Baby/Child Care',
        e: 'NobwRAlgJmBcYFsCmAXAhgYTSpBzA9gE4CeYANGAG5oA2ArkgM5yhW0NxgBCaARsQHoMACwg0oAAiyEk5MDT5IanHvyGjxUtDLABfALoUE2AMbCAyikLY8pWOGr0kAWVPDOjCADtcNWRXwAByRrFAh8L040LxhdAyA',
      },
    ],
    matchStrategy,
  },
  {
    className: 'fem-care',
    id: FILTER_NAMES.METACATEGORY,
    values: [
      {
        label: 'Fem Care',
        value: 'Fem Care',
        e: 'NobwRAlgJmBcYFsCmAXAhgYTSpBzA9gE4CeYANGAG5oA2ArkgM5yhW0NxgBiSCABFkJJyYGmgBGSGpx79BwgL4BdCgmwBjABYBlFIWx5SscNXpIAshs2dGEAHa4awivgAOSfSgj47nNHZgFZSA',
      },
    ],
    matchStrategy,
  },
  {
    className: 'adult-care',
    id: FILTER_NAMES.METACATEGORY,
    values: [
      {
        label: 'Adult Care',
        value: 'Adult Care',
        e: 'NobwRAlgJmBcYFsCmAXAhgYTSpBzA9gE4CeYANGAG5oA2ArkgM5yhW0NxgCCUdNKAAiyEk5MDTQAjJDU48+g4aIC+AXQoJsAYwAWAZRSFseUrHDV6SALLadnRhAB2uGqIr4ADkiMoI+R5xojjDKakA',
      },
    ],
    matchStrategy,
  },
];
// export const categoriesNav: AppNavigation[] = [
//   {
//     icon: '',
//     id: 'family-care',
//     name: 'Family Care',
//     path: '/t/m/Family%20Care',
//     className: 'family-care'
//   },
//   {
//     icon: '',
//     id: 'baby-and-child',
//     name: 'Baby & Child Care',
//     path: '/t/m/Baby%2FChild%20Care',
//     className: 'baby-and-child'
//   },
//   {
//     icon: '',
//     id: 'fem-care',
//     name: 'Fem Care',
//     path: '/t/m/Fem%20Care',
//     className: 'fem-care'
//   },
//   {
//     icon: '',
//     id: 'adult-care',
//     name: 'Adult Care',
//     path: '/t/m/Adult%20Care',
//     className: 'adult-care'
//   }
//   // {
//   //   icon: '',
//   //   id: 'family-care',
//   //   name: 'Family Care',
//   //   path: '/t/m/Family%20Care',
//   //   className: 'family-care'
//   // },
//   // {
//   //   icon: '',
//   //   id: 'baby-and-child',
//   //   name: 'Baby & Child Care',
//   //   path: '/t/m/Baby%2FChild%20Care',
//   //   className: 'baby-and-child'
//   // },
//   // {
//   //   icon: '',
//   //   id: 'fem-care',
//   //   name: 'Fem Care',
//   //   path: '/t/m/Adult%2FFem%20Care/Fem%20Care',
//   //   className: 'fem-care'
//   // },
//   // {
//   //   icon: '',
//   //   id: 'adult-care',
//   //   name: 'Adult Care',
//   //   path: '/t/m/Adult%2FFem%20Care/Adult%20Care',
//   //   className: 'adult-care'
//   // }
// ]

export const leftMenuList: AppNavigation[] = [
  {
    icon: '',
    id: 'capabilities',
    name: 'Tools',
    path: '/capabilities',
    className: '',
  },
  {
    icon: '',
    id: 'training',
    name: 'Training and Resources',
    path: '/training',
    className: '',
  },
  // {
  //   icon: '',
  //   id: 'resources',
  //   name: 'Resources',
  //   path: '/resources',
  //   className: ''
  // },
  {
    icon: '',
    id: 'about',
    name: 'About IRIS',
    path: '/about',
    className: '',
  },
];
export const rightMenuList: AppNavigation[] = [
  {
    icon: '',
    id: 'contact',
    name: 'Contact Us',
    path: '/help-center/contact-us',
    className: 'contactusbutton btn btn-animated border-radius-10',
  },
  {
    icon: '',
    id: 'request-access',
    name: 'Request Access',
    path: '/help-center/request-access',
    className:
      'btn-nav-link btn btn-primary btn-animated requestaccessbutton border-radius-10 text-white',
  },
];
